import  React ,{useState,useEffect} from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { Box, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../common/CustomDialog";
import DeleteIcon from '@mui/icons-material/Delete';
import StateDialog from "../common/StateDialog";
import { useSelector } from "react-redux";
import { getCollectionByCondition } from "../../utils/firebase/dynamic";
export default function AdminsTable({ change ,firechange }) {
    const navigate = useNavigate();
    const [search, setSearch] = React.useState("");
    const [rows, setRows] = useState([]);
    const token=useSelector(state=>state.auth.token)
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5); 
    const [deleteAction,setDeleteAction]=React.useState({
        visible:false,
        success:false,
        msg:""
    });
    
    const [selected4Action,setSelected4Action]=React.useState({
        id:null,
        action:false,
    })
    const [showDelete,setShowDelete]=React.useState(false);
    
    const columns = [
    ,
    { id: "name", label: "name", minWidth: "30%", align: "left" },
    { id: "email", label: "Email", minWidth: "30%", align: "center" },
    {
      id: "action",
      label: "Delete",
      minWidth: "30%",
      align: "center",
    },
  ];
  const formatRows = (input) => {
    let list = [];
    for (let item of input) {
      const { first_name, last_name, email, uid:id } = item;
      list.push({ name: first_name + " " + last_name, email, id });
    }
    setRows(list);
  };
  useEffect(() => {
    (async () => {
      const { data: list } = await getCollectionByCondition(
        "users",
        "isAdmin",
        "==",
        true
      );
      formatRows(list);
    })();
  }, [change]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleConfirmDelete=async()=>{
        try {
            const req=await fetch("https://us-central1-expertminute-net.cloudfunctions.net/api/addAdmin",{
                method:"POST",
                body:JSON.stringify({
                    userId:selected4Action.id
                })
            });
            const res=await req.json();
            // console.log("resFromDelete",res)
            if(res.isSuccess){
                if (
                res.message?.trim().toLowerCase()==="The user has no longer access to admin access.".trim().toLowerCase()
                ) {
                    setDeleteAction({ visible: true, success: true, msg: res.message });
                }else{
                    setDeleteAction({ visible: true, success: false, msg: res.message});
                }
                firechange(s=>!s)
            }else{
                throw new Error()
            }
        } catch (e) {
            // console.log(e.message)
            setDeleteAction({
                visible: true, success: false, msg: "Oops someting went wrong, failed to delete this admin"});
        }
        
    }
    
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor:"#F3F3F7", //theme.palette.action.hover,
        color: theme.palette.common.black,
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
        },
    }));
    
    return (
        <Paper sx={{ width: "90%", margin: 0,position:"relative",  }}>
            <Paper
                component="form"
                sx={{ p: '10px 4px', display: 'flex',boxShadow:"none", alignItems: 'center'}}
                >
                <Box  sx={{
                        border:"1px solid #D5D6D7",
                        borderRadius:3,
                        flex:1,
                        display:"flex",
                        justifyContent:"space-between",
                        marginRight:5
                        }}>
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search for admin"
                        inputProps={{ 'aria-label': 'search admin' }}
                        onChange={(e)=>setSearch(e.target.value)}
                    />
                    <IconButton type="button" sx={{ p: '10px',color:"#D5D6D7" }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                </Box>
                
                
            </Paper>
        <TableContainer sx={{ maxHeight: 440, }}>
            <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                {columns.map((column) => (
                    <StyledTableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    
                    >
                    {column.label}
                    </StyledTableCell>
                ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .filter(
                    (row) =>
                    row.name.toLowerCase().match(new RegExp(search.toLowerCase().trim())) ||
                    row.email.toLowerCase().match(new RegExp(search.toLowerCase().trim()))
                ).length>0?
                rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .filter(
                    (row) =>
                    row.name.toLowerCase().match(new RegExp(search.toLowerCase().trim())) ||
                    row.email.toLowerCase().match(new RegExp(search.toLowerCase().trim()))
                )
                
                .map((row) => {
                    return (
                    <TableRow 
                        
                        hover 
                        role="checkbox" 
                         key={row.id}>
                            {columns.map((column) => {
                            const value = row[column.id];
                            const id=row.id
                            return (
                                column.id==="action"?<TableCell key={column.id} id={id} align={column.align}>
                                        {id!==token&&<IconButton 
                                            onClick={()=>{
                                                setSelected4Action({
                                                    id,
                                                    name:row.name
                                                })
                                                setShowDelete(true);
                                            }}
                                            sx={{color:"#ab1414"}}>
                                            <DeleteIcon sx={{fontSize:30}} />
                                        </IconButton>}
                                        
                                </TableCell>:
                                
                                <TableCell key={column.id} align={column.align}>
                                { value}
                                </TableCell>
                                
                            
                            );
                        })}
                    </TableRow>
                    );
                }) : <div style={{
                    margin: 10,
                    fontSize: 24,
                }}>There is no match for this search</div>}
            </TableBody>
            </Table>
        </TableContainer>
            
        <TablePagination
            rowsPerPageOptions={[5]}
            component="div"
                count={rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .filter(
                        (row) =>
                            row.name.toLowerCase().match(new RegExp(search.toLowerCase().trim())) ||
                            row.email.toLowerCase().match(new RegExp(search.toLowerCase().trim()))
                    ).length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <CustomDialog 
            open={showDelete}
            header={"Delete admin"}
            handleClose={()=>{
            //    setDeleteAction({visible:false,success:true})
               setShowDelete(false)
            }
            }
            confirm={{
                color:"#D52341",
                text:"Delete",
                action:handleConfirmDelete
                
            }}
            text={`Are you sure that you want to delete ${selected4Action.name}?`}
            text1={["Deteleing admin will prevent him from using Exm admin dashboard any more ",
            ]}
            cancel={{text:"Cancel"}}
           
        />
        <StateDialog 
            open={deleteAction.visible}
            handleClose={()=>setDeleteAction(p=>({...p,visible:false}))}
            text={deleteAction.success?"Successfuly deleted the admin":deleteAction.msg}
            header={"Delete Admin"}
            state={deleteAction.success?"success":"fail"}
        />
        </Paper>
    );
}
